//import { Link } from 'react-router-dom';

const Navbar = () => (
  <nav>
  </nav>
);

export default Navbar;
